import * as React from 'react';
import { AppRoute } from '../../routes';
import { makeListGroupComponent } from './ListGroup';

type Props<TValue, TOptions> = {
    groups: Array<{
        name: string;
        items: TValue[];
        headerComponent?: React.ReactElement;
        footerComponent?: React.ReactElement;
    }>;
    component: React.FunctionComponent<{
        testId?: string;
        value: TValue;
        appRoute?: AppRoute;
        isLast: boolean;
        options?: TOptions;
        onClick?: () => void;
    }>;
    componentTestId?: string;
    appRoute?: AppRoute;
    options?: TOptions;
    navigationFn?: (arg: TValue) => void;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function makeListGroupsComponent<TValue, TOptions = never>() {
    const ListGroupComponent = makeListGroupComponent<TValue, TOptions>();

    const component: React.FC<Props<TValue, TOptions>> = (props) => {
        const ListItemComponent = props.component;

        return (
            <div>
                {props.groups.map((group, groupIndex) => (
                    <ListGroupComponent
                        key={groupIndex}
                        group={group}
                        component={ListItemComponent}
                        appRoute={props.appRoute}
                        options={props.options}
                        componentTestId={props.componentTestId}
                        style={{ marginTop: groupIndex > 0 ? '16px' : undefined }}
                        navigationFn={props.navigationFn}
                    />
                ))}
            </div>
        );
    };

    return component;
}
